export default __webpack_public_path__ + "static/media/piggy.0d5eafcf.svg";